import { Link, useNavigate } from "react-router-dom";
import "./HomePage.css";
import logo from "../assets/krops-capital-logo.png";

function HomePage() {
  const navigate = useNavigate();

  return (
    <>
      {/* Top Bar */}
      <div className="topbar">
        <div className="topbar-title">KROPS CAPITAL</div>
      </div>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <img
            src={logo}
            alt="Krops Capital Logo"
            className="hero-logo"
          />

          <h1 className="hero-tagline">
            Managing and growing your capital with trust and expertise.
          </h1>

          <p>
            Krops Capital provides structured financial solutions that help
            businesses expand, stabilize, and scale sustainably.
          </p>

          <Link to="/know-more">
            <button>Know More</button>
          </Link>
        </div>
      </section>

      {/* Who We Are */}
      <section className="info">
        <h2>Who We Are</h2>
        <p>
          Krops Capital is a financial advisory and capital solutions firm
          focused on enabling long-term business growth through customized
          funding strategies.
        </p>

        <div className="info-buttons">
          <button
            className="primary-btn"
            onClick={() => navigate("/about")}
          >
            Learn More
          </button>

          <button
  className="secondary-btn"
  onClick={() => navigate("/contact")}
>
  Contact Us
</button>

        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <h2 className="services-title">SERVICES</h2>

        <div className="services">
          <div className="card">
            <span className="icon">📊</span>
            <p>TAXATION ADVISORY</p>
          </div>

          <div className="card">
            <span className="icon">🏢</span>
            <p>CORPORATE SOLUTIONS</p>
          </div>

          <div className="card">
            <span className="icon">🏘️</span>
            <p>REAL ESTATE ADVISORY / MANAGEMENT</p>
          </div>

          <div className="card">
            <span className="icon">💼</span>
            <p>FINANCIAL INTERMEDIARY & WEALTH MANAGEMENT</p>
          </div>

          <div className="card">
            <span className="icon">💰</span>
            <p>LENDING SOLUTIONS / LOAN SYNDICATION</p>
          </div>

          <div className="card">
            <span className="icon">🧾</span>
            <p>ESTATE & SUCCESSION PLANNING</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        © 2025 Krops Capital. All rights reserved.
      </footer>
    </>
  );
}

export default HomePage;


